import React from 'react';
import { getTemplate, getUiOptions } from '@rjsf/utils';

// Every widget in this theme renders its own floating label (TextField/Select) or inline
// label (Checkbox) already — RJSF's default FieldTemplate would otherwise also render a
// separate static <label> above the field, showing the label twice. This template skips
// that and only adds the description (if any), errors, and help below the widget itself.
const FieldTemplate = (props) => {
  const { children, errors, help, description, hidden, uiSchema, registry } = props;
  const uiOptions = getUiOptions(uiSchema);
  const WrapIfAdditionalTemplate = getTemplate('WrapIfAdditionalTemplate', registry, uiOptions);

  if (hidden) {
    return <div className="hidden">{children}</div>;
  }

  return (
    <WrapIfAdditionalTemplate {...props}>
      {children}
      {description}
      {errors}
      {help}
    </WrapIfAdditionalTemplate>
  );
};

export default FieldTemplate;
